import clsx from 'clsx';

import { PackPopupType } from '@nf/types/promotion';
import { usePackPopupStates } from '@/features/promotion/cwc-risk-free-bet/hooks/use-pack-popup-states';

export const PackVoucherBadge = ({ className }: { className?: string }) => {
	const { data: packPopupStates } = usePackPopupStates([PackPopupType.RedDot], { shouldCheck: true });
	const isBadgeVisible = packPopupStates?.[0].IsShow;

	return isBadgeVisible ? (
		<div className={clsx('badge badge--point', className)}></div>
	) : null;
};